import axios from '../axios';

export const getMInfo = () => {
  let osVersion = '-';
  let width = '';
  let height = '';
  const nVer = navigator.appVersion;
  const nAgt = navigator.userAgent;
  let browser = navigator.appName;
  let version = '' + parseFloat(navigator.appVersion);
  let nameOffset, verOffset, ix;

  if (!window.innerWidth) {
    if (!(document.documentElement.clientWidth === 0)) {
      //strict mode
      width = document.documentElement.clientWidth;
      height = document.documentElement.clientHeight;
    } else {
      //quirks mode
      width = document.body.clientWidth;
      height = document.body.clientHeight;
    }
  } else {
    //w3c
    width = window.innerWidth;
    height = window.innerHeight;
  }

  // Opera
  if ((verOffset = nAgt.indexOf('Opera')) !== -1) {
    browser = 'Opera';
    version = nAgt.substring(verOffset + 6);
    if ((verOffset = nAgt.indexOf('Version')) !== -1) {
      version = nAgt.substring(verOffset + 8);
    }
  }
  // Opera Next
  if ((verOffset = nAgt.indexOf('OPR')) !== -1) {
    browser = 'Opera';
    version = nAgt.substring(verOffset + 4);
  }
  // Legacy Edge
  else if ((verOffset = nAgt.indexOf('Edge')) !== -1) {
    browser = 'Microsoft Legacy Edge';
    version = nAgt.substring(verOffset + 5);
  }
  // Edge (Chromium)
  else if ((verOffset = nAgt.indexOf('Edg')) !== -1) {
    browser = 'Microsoft Edge';
    version = nAgt.substring(verOffset + 4);
  }
  // MSIE
  else if ((verOffset = nAgt.indexOf('MSIE')) !== -1) {
    browser = 'Microsoft Internet Explorer';
    version = nAgt.substring(verOffset + 5);
  }
  // Chrome
  else if ((verOffset = nAgt.indexOf('Chrome')) !== -1) {
    browser = 'Chrome';
    version = nAgt.substring(verOffset + 7);
  }
  // Safari
  else if ((verOffset = nAgt.indexOf('Safari')) !== -1) {
    browser = 'Safari';
    version = nAgt.substring(verOffset + 7);
    if ((verOffset = nAgt.indexOf('Version')) !== -1) {
      version = nAgt.substring(verOffset + 8);
    }
  }
  // Firefox
  else if ((verOffset = nAgt.indexOf('Firefox')) !== -1) {
    browser = 'Firefox';
    version = nAgt.substring(verOffset + 8);
  }
  // MSIE 11+
  else if (nAgt.indexOf('Trident/') !== -1) {
    browser = 'Microsoft Internet Explorer';
    version = nAgt.substring(nAgt.indexOf('rv:') + 3);
  }
  // Other browsers
  else if (
    (nameOffset = nAgt.lastIndexOf(' ') + 1) <
    (verOffset = nAgt.lastIndexOf('/'))
  ) {
    browser = nAgt.substring(nameOffset, verOffset);
    version = nAgt.substring(verOffset + 1);
    if (browser.toLowerCase() === browser.toUpperCase()) {
      browser = navigator.appName;
    }
  }

  if ((ix = version.indexOf(';')) !== -1) version = version.substring(0, ix);
  if ((ix = version.indexOf(' ')) !== -1) version = version.substring(0, ix);
  if ((ix = version.indexOf(')')) !== -1) version = version.substring(0, ix);

  if (isNaN(parseInt('' + version, 10))) {
    version = '' + parseFloat(navigator.appVersion);
  }

  let os = '-';
  const clientStrings = [
    { s: 'Windows 10', r: /(Windows 10.0|Windows NT 10.0)/ },
    { s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/ },
    { s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/ },
    { s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/ },
    { s: 'Windows Vista', r: /Windows NT 6.0/ },
    { s: 'Windows Server 2003', r: /Windows NT 5.2/ },
    { s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/ },
    { s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/ },
    { s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/ },
    { s: 'Windows 98', r: /(Windows 98|Win98)/ },
    { s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/ },
    { s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
    { s: 'Windows CE', r: /Windows CE/ },
    { s: 'Windows 3.11', r: /Win16/ },
    { s: 'Android', r: /Android/ },
    { s: 'Open BSD', r: /OpenBSD/ },
    { s: 'Sun OS', r: /SunOS/ },
    { s: 'Chrome OS', r: /CrOS/ },
    { s: 'Linux', r: /(Linux|X11(?!.*CrOS))/ },
    { s: 'iOS', r: /(iPhone|iPad|iPod)/ },
    { s: 'Mac OS X', r: /Mac OS X/ },
    { s: 'Mac OS', r: /(Mac OS|MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
    { s: 'QNX', r: /QNX/ },
    { s: 'UNIX', r: /UNIX/ },
    { s: 'BeOS', r: /BeOS/ },
    { s: 'OS/2', r: /OS\/2/ },
    {
      s: 'Search Bot',
      r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/,
    },
  ];

  for (let id in clientStrings) {
    let cs = clientStrings[id];
    if (cs.r.test(nAgt)) {
      os = cs.s;
      break;
    }
  }

  if (/Windows/.test(os)) {
    osVersion = /Windows (.*)/.exec(os)[1];
    os = 'Windows';
  }

  switch (os) {
    case 'Mac OS':
    case 'Mac OS X':
    case 'Android':
      osVersion = /(?:Android|Mac OS|Mac OS X|MacPPC|MacIntel|Mac_PowerPC|Macintosh) ([._\d]+)/.exec(
        nAgt
      )[1];
      break;

    case 'iOS':
      osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
      osVersion = osVersion[1] + '.' + osVersion[2] + '.' + (osVersion[3] | 0);
      break;
    default:
  }

  let browserColorDepth = window.screen.colorDepth.toString();
  const scl = window.screen.colorDepth;
  if (scl > 1 && scl < 4) {
    browserColorDepth = "1";
  } else if (scl > 4 && scl < 8) {
    browserColorDepth = "4";
  } else if (scl > 8 && scl < 15) {
    browserColorDepth = "8";
  } else if (scl > 16 && scl < 24) {
    browserColorDepth = "16";
  } else if (scl > 24 && scl < 32) {
    browserColorDepth = "24";
  } else if (scl > 32 && scl < 48) {
    browserColorDepth = "32";
  } else if (scl > 48) {
    browserColorDepth = "48";
  }

  const dataObj = {
    browserJavaEnabled: navigator.javaEnabled(), //включено ли Java
    browserJavascriptEnabled: true, //поддерживается ли JavaScript
    browserCookieEnabled: navigator.cookieEnabled, //поддерживаются ли куки
    browserUserAgent: window.navigator.userAgent, //заголовки браузера
    platform: navigator.platform, //платформа
    browserColorDepth, //цветность дисплея
    browserLanguage: window.navigator.language, //язык браузера
    browserTZ: -180, //временная метка браузера
    browserTZoffset: -3, //время от Гринвича
    browserScreenWidth: width, //разрешение окна браузера
    browserScreenHeight: height, //разрешение окна браузера
    browser: browser, //тип браузера
    browserVersion: version, //версия браузера
    osVersion: osVersion, //версия операционной системы
    os: navigator.platform, //операционная система
    appCodeName: navigator.appCodeName, //имя приложения из User-Agent
    appName: navigator.appName, //имя приложения из User-Agent
    product: navigator.product, //продукт
    billAddr: {
      billAddrCity: 'Moscow',
      billAddrCountry: '643',
      billAddrLine1: 'Odesskaya street',
      billAddrLine2: '2',
      billAddrLine3: '',
      billAddrPostCode: '117638',
      billAddrState: 'MOW',
    },
    shipAddr: {
      shipAddrCity: 'Moscow',
      shipAddrCountry: '643',
      shipAddrLine1: 'Odesskaya street',
      shipAddrLine2: '2',
      shipAddrLine3: '',
      shipAddrPostCode: '117638',
      shipAddrState: 'MOW',
    },
    addrMatch: 'Y',
    threeDSRequestorAuthenticationInfo: 'AUTH_INFO',
    threeDSRequestorPriorAuthenticationInfo: 'PRIOR_AUTH_I'
  };

  return dataObj;
};
